import { Controller } from "@hotwired/stimulus"
import select2 from 'select2'
const $ = select2()

function formatOption(data) {
  let special = ''
  if(data.special) special = `<span class="label primary">SPECIAL</span>`
  let tpl = `
    <div style="width: 80px">
      <span class="label ${data.sex == 'm' ? 'primary' : 'alert'}">${data.code}</span>
    </div>
    <div style="width: 80px">
      ${special}
    </div>
    <div>${data.name}</div>
  `
  return $(`<div style="display: flex">${tpl}</div>`)
}

function formatSelection(data) {
  if(!data?.id) return '';

  let special = ''
  if(data.special) special = `<span class="label primary">SPECIAL</span>`
  let tpl = `
    <div style="margin-right: 10px;">
      <span class="label ${data.sex == 'm' ? 'primary' : 'alert'}">${data.code}</span>
    </div>
    <div style="margin-right: 10px;">
      ${special}
    </div>
    <div>${data.name}</div>
  `
  return $(`<div style="display: flex">${tpl}</div>`)
}

export default class extends Controller {
  static targets = [
    'category',
    'specialClasses',
    'sex'
  ]
  static values = {
    categories: Array,
    person: Object,
    admin: { type: Boolean, default: true }
  }

  connect() {
    // select2 does not work with addEventListener
    if(this.hasSexTarget) {
      $(this.sexTarget).on('change', ()=> this.updateCategories())
    }
    if(this.hasCategoryTarget) {
      $(this.categoryTarget).on('change', ()=> this.updateSpecial())
      Array.from(this.categoryTarget.options).forEach((o)=> o.remove())
      this.updateCategories()
    }
    this.updateSpecial()
  }

  updateCategories() {
    // filter categories by sex
    let sex = this.hasSexTarget && this.sexTarget.value
    sex = sex || this.personValue?.sex || null

    let categories = this.categoriesValue.filter((c)=> c.sex == sex)

    $(this.categoryTarget).empty()
    $(this.categoryTarget).select2({
      allowClear: true,
      placeholder: 'foooo',
      data: categories,
      templateResult: formatOption,
      templateSelection: formatSelection,
    })

    if(this.personValue.category_id && categories.find((c)=> c.id == this.personValue.category_id)) {
      $(this.categoryTarget).val(this.personValue.category_id).trigger('change')
    } else {
      $(this.categoryTarget).val(null).trigger('change')
    }
  }

  updateSpecial() {
    let cat = null;
    if(this.hasCategoryTarget) {
      let catId = $(this.categoryTarget).val()
      cat = this.categoriesValue.find((c)=> c.id == catId)
    }
    cat = cat  || this.personValue.category || {}

    if(this.hasSpecialClassesTarget) {
      if(cat?.special && this.adminValue) {
        this.specialClassesTarget.classList.remove('hide')
        this.specialClassesTarget.querySelectorAll('select, input').forEach((s)=> s.removeAttribute('disabled'))
      } else {
        this.specialClassesTarget.classList.add('hide')
        this.specialClassesTarget.querySelectorAll('select, input').forEach((s)=> s.setAttribute('disabled', true))
      }
    }
  }
}
